import React from 'react'
import { Grid } from '@material-ui/core'
import { TableControlsButtonGroup } from '../../../../../theme/Table'
import { stateList } from '../../../../../common/helpers'
import LocaleFilter from './localeFilter'
import { TableControls, TableLabel } from './styles'
import ExportButton from './export'
import Search from './search'
import PaidLeaveTypeFilter from './paidLeaveTypeFilter'
import DateFilter from './dateFilter'

const StatelessTableControls = ({
  isLoading,
  showLocaleFilter,
  showPaidLeaveFilter,
  showDateFilter,
  showExport,
  showExportDropdown,
  exportOptions,
  showSearch,
  filters,
  filterOptions,
  eventHandlers,
  total,
  recordType,
  stateListFiltered,
  locales
}) => (
  <TableControls>
    <Grid container>
      <Grid item xs={7}>
        <TableControlsButtonGroup>
          {showDateFilter ? (
            <DateFilter
              {...{
                isLoading,
                eventHandlers,
                maxDropDownHeight: '40vh',
                filterOptions
              }}
            />
          ) : null}
          {showLocaleFilter ? (
            <LocaleFilter
              {...{
                isLoading,
                eventHandlers,
                stateList,
                stateListFiltered,
                maxDropDownHeight: '40vh',
                locales
              }}
            />
          ) : null}
          {filters.state !== '' ? (
            <TableLabel>
              Showing {total} {recordType} in {filters.state.locale.name}
            </TableLabel>
          ) : (
            <TableLabel>
              Showing {total} {recordType}
            </TableLabel>
          )}
          {showPaidLeaveFilter ? (
            <PaidLeaveTypeFilter
              {...{
                isLoading,
                eventHandlers,
                filterOptions
              }}
            />
          ) : null}
        </TableControlsButtonGroup>
      </Grid>
      <Grid item xs={5}>
        <Grid container justify="flex-end" alignItems="center" spacing={8}>
          {showExport || showExportDropdown ? (
            <ExportButton
              {...{
                eventHandlers,
                showExportDropdown,
                exportOptions,
                isLoading
              }}
            />
          ) : null}
          {showSearch ? (
            <Search
              {...{
                showExport,
                showExportDropdown,
                eventHandlers,
                isLoading
              }}
            />
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  </TableControls>
)

export default StatelessTableControls
